import {
  HttpEventType,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Auth } from 'aws-amplify';
import { Subscription, throwError } from 'rxjs';
import { finalize, catchError } from 'rxjs/operators';
import { APIService, GetTokensQuery } from 'src/app/API.service';
import { environment } from 'src/environments/environment';
import { SCanvasComponent } from '../../canvas/canvas.component';
import { D2TApi } from '../utils/d2tApi';
import { InvoiceTableComponent } from './invoice-table/invoice-table.component';
import { InvoicePlusTableComponent } from './invoice-plus-table/invoice-plus-table.component';

@Component({
  selector: 'app-ocr-plus-invoice',
  templateUrl: './ocr-plus-invoice.component.html',
  styleUrls: ['./ocr-plus-invoice.component.css'],
})
export class OcrPlusInvoiceComponent {
  @ViewChild('canvasComp') canvasCompRf: ElementRef<SCanvasComponent>;
  @ViewChild('canvasCompContain') canvasCompContain: ElementRef;
  @ViewChild('receiptTable') receiptTableRf: ElementRef<InvoiceTableComponent>;
  @ViewChild('invoicePlusTable')
  invoicePlusTableRf: ElementRef<InvoicePlusTableComponent>;
  fileName = '';
  uploadProgress: number | null;
  uploadSub: Subscription | null;
  imageURL: string;
  windowHeight = window.innerHeight - 20;
  loadingFlag = true;
  canvasComp: SCanvasComponent;
  receiptTbl: InvoiceTableComponent;
  err: any;
  error: string;
  dragAreaClass: string;
  draggedFiles: any;
  user: any;
  token: GetTokensQuery | null;
  showNeedTopUp: boolean;
  invoicePlusTbl: InvoicePlusTableComponent;
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private api: APIService
  ) {}

  async ngOnInit() {
    this.dragAreaClass = 'dragarea';
    this.user = await Auth.currentUserInfo();
    if (this.user) this.token = await this.api.GetTokens(this.user.username);
  }

  ngAfterViewInit() {
    var canvasComp = (this.canvasComp = this
      .canvasCompRf as unknown as SCanvasComponent);
    canvasComp.width = this.canvasCompContain.nativeElement.offsetWidth - 60;
    canvasComp.play();
    // canvasComp.wordClicked = (word) => {
    //   receiptTbl.wordClicked(word);
    // };
    this.invoicePlusTbl = this
      .invoicePlusTableRf as unknown as InvoicePlusTableComponent;

    var receiptTbl = (this.receiptTbl = this
      .receiptTableRf as unknown as InvoiceTableComponent);

    receiptTbl.receiptItemOver = (item) => {
      receiptTbl.unchooseTr();
      item.chosen = true;
      canvasComp.unchooseTr();
      const p = canvasComp.itemOver(item);
      if (p) {
        const elem = document.getElementsByClassName('canvasCompContain');
        elem[0].scroll({
          left: p[0],
          top: p[1] - 100,
          behavior: 'smooth',
        });
      }
    };

    this.route.queryParams.subscribe((params) => {
      this.fileOcrUid(params['uid']);
    });
  }

  onFileChange(event: any) {
    let files: FileList = event.target.files;
    this.saveFiles(files);
  }

  @HostListener('dragover', ['$event']) onDragOver(event: any) {
    this.dragAreaClass = 'droparea';
    event.preventDefault();
  }
  @HostListener('dragenter', ['$event']) onDragEnter(event: any) {
    this.dragAreaClass = 'droparea';
    event.preventDefault();
  }
  @HostListener('dragend', ['$event']) onDragEnd(event: any) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
  }
  @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
  }
  @HostListener('drop', ['$event']) onDrop(event: any) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files) {
      let files: FileList = event.dataTransfer.files;
      this.saveFiles(files);
    }
  }

  saveFiles(files: FileList) {
    if (files.length > 1) this.error = 'Only one file at time allow';
    else {
      this.error = '';
      let file = files[0];
      console.log(file.size, file.name, file.type);
      this.draggedFiles = files;
      console.log(files);
      // File Preview
      this.filePreview(file);
      // this.fileOcrTst()
      this.fileOcr(file);
    }
  }
  fileOcr(file) {
    if (file.size > 4000000) {
      alert('File size is too big. Max 4mb');
      return;
    }
    this.fileName = file.name;
    const formData = new FormData();
    formData.append('file', file);

    var receiptTbl = this.receiptTbl;

    receiptTbl.restart();
    this.canvasComp.restart();
    this.err = null;
    this.loadingFlag = true;
    const d2tApi = new D2TApi(this.http, this.token);
    const upload$ = d2tApi.ocrPlusInvoice(formData);
    upload$.pipe(
      catchError(this.handleError.bind(this)),
      finalize(() => {
        this.loadingFlag = false;
        this.reset();
      })
    );

    this.uploadSub = upload$.subscribe((event) => {
      console.log('event.type', event.type);

      if (event.type == HttpEventType.UploadProgress && event.total) {
        this.uploadProgress = Math.round(100 * (event.loaded / event.total));
      } else if (event.type == HttpEventType.Response) {
        this.loadingFlag = false;

        const body = event.body as any;
        if (body.error) {
          if (body.needTopUp) {
            this.showNeedTopUp = true;
          } else {
            alert(body.error);
          }
          return;
        }
        receiptTbl.displayTable(event.body);
        this.invoicePlusTbl.displayTable(event.body);
        // console.log(event);
        this.canvasComp.setOcr(event.body);
      }
    });
  }

  fileOcrUid(uid = '') {
    var receiptTbl = this.receiptTbl;

    this.err = null;
    this.loadingFlag = true;
    const d2tApi = new D2TApi(this.http, this.token);
    const request$ = d2tApi.ocrPlusInvoiceTst(uid);
    request$
      .pipe(
        catchError(this.handleError.bind(this)),
        finalize(() => {
          this.loadingFlag = false;
          this.reset();
        })
      )

      .subscribe((data: any) => {
        receiptTbl.displayTable(data);
        this.invoicePlusTbl.displayTable(data);
        this.canvasComp.setOcr(data);
        var canvasComp = this.canvasComp;
        if (!data.imgBase64 || data.imgBase64 == '') {
          canvasComp.imageURL =
            'https://doc2txt-images.s3.eu-west-3.amazonaws.com/receipt1.jpg';
        }
        canvasComp.play();
      });
  }

  // Handle API errors
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      this.showError('An error occurred:' + error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      this.showError(`${error.message}`);
    }

    // return an observable with a user-facing error message
    return throwError('פעולה נכשלה');
  }

  filePreview(file) {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageURL = reader.result as string;
      var canvasComp = this.canvasComp;
      canvasComp.imageURL = this.imageURL;
      canvasComp.play();
    };
    reader.readAsDataURL(file);
  }

  clear() {
    var canvasComp = this.canvasComp;
    canvasComp.clear();
  }
  showError(err) {
    this.err = err;
  }

  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
  }
}
